import "./SportsKinesiology.module.css";
import Header from "@/reusable_sections/Header";
import HeroDelCurso from "./sections/HeroDelCurso";
import DetallesDelCurso from "./sections/DetallesDelCurso";
import ScheduleInspection from "./sections/ScheduleInspection";
import Footer from "@/reusable_sections/Footer";
export default function SportsKinesiologyPage() {
  return <div>
      <Header />
      <HeroDelCurso />
      <DetallesDelCurso />
      <ScheduleInspection />
      <Footer />
    </div>;
}